import { forwardRef } from 'react';

import { Typography, TypographyProps } from '@material-ui/core';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = () =>
  createStyles({
    root: {},
  });

export interface SidebarSectionTitleProps
  extends Omit<TypographyProps, 'classes'>,
    WithStyles<typeof styles> {}

const SidebarSectionTitleMui = forwardRef<
  HTMLElement,
  SidebarSectionTitleProps
>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <Typography
      variant="h5"
      className={classNames(className, classes.root)}
      {...rest}
      component="h3"
      // Cast needed because MUI's Typography ref type doesn't account for the component prop
      ref={ref as React.Ref<HTMLHeadingElement>}
    >
      {children}
    </Typography>
  );
});

SidebarSectionTitleMui.displayName = 'SidebarSectionMui.Title';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore SidebarSection and delete. */
export default withStyles(styles)(SidebarSectionTitleMui);
